import { IdDisplayPair, SelectOption } from '@models/shared.model';

export class StationFilterOptionsResponse {
    constructor(
        public maxNumberOfUsers: number | null,
        public type: IdDisplayPair[] = [],
        public communicationType: IdDisplayPair[] = [],
        public status: IdDisplayPair[] = [],
    ) {}

    static initial() {
        return new StationFilterOptionsResponse(null);
    }
}

export class StationFilterOptions {
    constructor(
        public maxNumberOfUsers: number | null,
        public type: SelectOption[] = [],
        public communicationType: SelectOption[] = [],
        public status: SelectOption[] = [],
    ) {}

    static initial() {
        return new StationFilterOptions(null);
    }
}
